// MetricCard.tsx

import React from 'react';
import { MetricCard } from './config';
import { ArrowRightOutlined } from '@ant-design/icons';

interface TopMetricCardProps {
  data: MetricCard;
  index: number;
  onClick?: () => void; // Added logic
}

const getColorClass = (index: number) => {
  const colors = [
    'border-orange-500',
    'border-purple-500',
    'border-blue-500',
    'border-green-500',
    'border-red-500',
    'border-teal-500',
  ];
  return colors[index % colors.length];
};

export const TopMetricCard: React.FC<TopMetricCardProps> = ({ data, index, onClick }) => {
  const colorClass = getColorClass(index);
  const textColorClass = colorClass.replace('border-', 'text-');

  return (
    <div
      className={`
        p-4 rounded-lg shadow-sm border-l-4
        ${colorClass}
        relative flex flex-col justify-between h-full bg-white
      `}
    >
      <div className="flex justify-between items-start">
        <h3 className="text-sm font-semibold text-gray-700">{data.title}</h3>
        {/* Added onClick here */}
        <span
          className='h-8 w-8 flex items-center justify-center rounded-full bg-gray-100 cursor-pointer'
          onClick={onClick}
        >
          <ArrowRightOutlined className={`${textColorClass}`} />
        </span>
      </div>

      <div className="mt-2 flex items-baseline">
        <span className="text-2xl font-bold text-gray-900">{data.current}</span>
        <span className="ml-2 text-xs text-gray-500">Total: {data.total.toLocaleString()}</span>
      </div>
    </div>
  );
};

interface BottomMetricCardProps {
  data: MetricCard;
}

export const BottomMetricCard: React.FC<BottomMetricCardProps> = ({ data }) => {
  return (
    <div className={`p-4 rounded-lg flex items-center justify-start h-full bg-white`}>
      <div className="flex items-center space-x-3">
        <div
          className={`p-3 rounded-lg text-2xl flex items-center justify-center`}
          style={{
            backgroundColor: data?.bgColor?.replace('bg-green-100', 'rgba(180, 255, 180, 0.75)')
              .replace('bg-blue-100', 'rgba(180, 200, 255, 0.75)')
              .replace('bg-red-100', 'rgba(255, 180, 180, 0.75)')
              .replace('bg-teal-100', 'rgba(180, 255, 255, 0.75)')
          }}
        >
          <div
            className={`text-2xl`}
            style={{
              color: data?.bgColor?.replace('100', '500').replace('bg-', '')
            }}
          >
            {data.icon}
          </div>
        </div>
      </div>

      <div className="ml-4 flex flex-col">
        <p className="text-base font-semibold text-gray-800">{data.title}</p>
        <div className='flex'>
          <p className="text-3xl font-bold text-gray-800">{data.current}</p>
          <p className="text-sm text-gray-400 mt-3 ml-2">Total: {data.total.toLocaleString()}</p>
        </div>
      </div>
    </div>
  );
};